'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseQueryParams = parseQueryParams;
exports.readCookie = readCookie;
exports.getCurrentDateWithWeek = getCurrentDateWithWeek;
function parseQueryParams(queryString) {
  var query = {};
  var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
};

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

function getCurrentDateWithWeek(now) {
  /*
    Using the format "YYYYMMDDWW" gives Omniture a lot of flexibity in creating
    a segment to choose hits INBETWEEN 2 dates, which isn't supported right now
     
    We Offset UTC behind 6 Hours to get Mountain Time, This helps us tackle and
    hopefully eradicate the "Daylight Saving" Problems
  */
  now.setUTCHours(now.getUTCHours() - 7);
  return lpad(now.getUTCFullYear().toString(), "0", 4) + lpad((now.getUTCMonth() + 1).toString(), "0", 2) + lpad(now.getUTCDate().toString(), "0", 2) + "W" + lpad(getWeek(now).toString(), "0", 2);
};

function lpad(str, padString, length) {
  while (str.length < length) {
    str = padString + str;
  }return str;
};

function getWeek(now) {
  /*
     Custom Property to get week of the year
     The first week of the year is the week with atleast 4 days from from the new year hence Jan 4th is used
  */
  var jan4th = new Date(now.getUTCFullYear(), 0, 4);
  return Math.ceil(((now - jan4th) / 86400000 + jan4th.getUTCDay() + 1) / 7);
}


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/dom_helper.js
// module id = 930
// module chunks = 48 49 51